import { acceptHMRUpdate, defineStore } from 'pinia';

export const useFooterStore = defineStore({
    id: 'footer',
    state: () => ({
        footer_links: [],

    }),

    actions: {
        async fetchFooterLinks(apiKey: any, opts: object,
                               nuxtApp: any = null,redisCacheBurst = false) {
            const {
                getFooterLinks
            } = await import("@/services-optimized/builderService")

            this.footer_links = await getFooterLinks(apiKey, opts,nuxtApp,redisCacheBurst);

            return true
        },

    }
});

// Pinia hot reload
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useHeaderStore, import.meta.hot))
}

